import { Provider } from '@angular/core';
import { provideSoftAppsModule, withSoftAppsModuleRoutes } from '@softapps/core';
import { productRelocationRoutes } from './product-relocation.routes';

export function provideProductRelocationModule(): Provider[] {
  return [
    provideSoftAppsModule(
      {
        name: 'product-relocation',
        title: 'Umlagerung Artikel',
        icon: 'box-arrow-down-arrow-up',
        permission: 'SOFTAPPS.LAGER.ARTIKEL_UMLAGERUNG',
        route: '/product-relocation',
      },
      withSoftAppsModuleRoutes({
        app: productRelocationRoutes,
      })
    ),
  ];
}

export function providePalletRelocationModule() {
  return [
    provideSoftAppsModule(
      {
        name: 'pallet-relocation',
        title: 'Umlagerung Paletten',
        icon: 'fa-regular fa-pallet-boxes',
        permission: 'SOFTAPPS.LAGER.PALETTEN_UMLAGERUNG',
        route: '/product-relocation',
      },
      withSoftAppsModuleRoutes({
        app: productRelocationRoutes,
      })
    ),
  ];
}
